<template>
  <div class="offcanvas offcanvas-end" tabindex="-1" :id="offcanvas_id" data-bs-backdrop="static" :aria-labelledby="`${offcanvas_id}_label`">
    <div class="offcanvas-header">
      <button class="btn-back" type="button" name="button" data-test="btnCloseOffcanvas" data-bs-dismiss="offcanvas" aria-label="Close" @click="doCancel">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>
      <h5 class="offcanvas-title d-block" :id="`${offcanvas_id}_label`">Pague seu plano</h5>
    </div>
    <div class="offcanvas-body">
      <p>
        Confira abaixo os dados do seu plano e faÃ§a o pagamento
      </p>

      <div id="checkout">
        <!-- Checkout will insert the payment form here -->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.offcanvas {
  // width:                                510px !important;
  // padding:                              40px;

  .offcanvas-header,
  .offcanvas-body {
    padding:                            0;
  }

  .offcanvas-header {
    display:                            block;
  }

  .offcanvas-title {
    color:                              var(--Brand-Primary, #1B294A);
    font-size:                          38px;
    font-weight:                        300;
    line-height:                        normal;
    margin:                             26px 0;
  }

  .offcanvas-body {
    p,
    li {
      color:                            var(--Brand-Primary, #1B294A);
      font-size:                        var(--font-size-14);
      font-weight:                      300;
      line-height:                      140%; /* 19.6px */
      margin-bottom:                    26px;
    }
  }

  .offcanvas-footer {
    display:                            flex;
    flex-direction:                     column;
    gap:                                26px;

    .btn {
      font-size:                        var(--font-size-14);
      font-weight:                      700;
      line-height:                      normal;
      letter-spacing:                   4.2px;
      text-align:                       center;
      text-transform:                   uppercase;
      // gap:                              10px;
      // flex:                             1 0 0;
      width:                            100%;
      padding:                          20px;
    }

    .btn-success {
      color:                            var(--Shades-W, #FFF);
      // margin-top:                       26px;
    }
  }
}
</style>

<script>
import { inject } from "vue";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe("pk_test_51Oqcal06iKAIDsqJYwCAsFEsHMmh9p4aw3SIe3xq4TYtS4V2zbZfUH8uEskBHrFhCSrnBpD3vUZUlKtqg9XRT39I00VCqEpUtB");

export default {
  name: 'BaseGenericOffcanvas',
  props: ['offcanvas_id'],
  data: () => ({
    offcanvas_checkout: null,
    priceID: null,
    quantity: null,
    clinicUUID: null,
    clinicEmail: null,
    clinicName: null,
    checkout: null
  }),
  mounted() {
  },
  methods: {
    show(options = {}) {
      this.priceID = options.priceID
      this.quantity = options.quantity
      this.clinicUUID = options.clinicUUID
      this.clinicEmail = options.clinicEmail
      this.clinicName = options.clinicName

      this.offcanvas_checkout = new bootstrap.Offcanvas(document.getElementById(this.offcanvas_id)).show();

      this.initializeCheckout()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    doConfirm() {
      this.offcanvas_checkout = null;
      this.checkout.destroy()
      this.resolvePromise(true)
    },

    doCancel() {
      this.offcanvas_checkout = null;
      this.checkout.destroy()
      this.resolvePromise(false)
    },

    async initializeCheckout() {
      this.checkout = null;

      let params = {
        priceID: this.priceID,
        quantity: this.quantity,
        clinicUUID: this.clinicUUID,
        clinicEmail: this.clinicEmail,
        clinicName: this.clinicName
      };

      try {
        const fetchClientSecret = await this.$stripeService.createCheckoutSession(params);
        console.log("fetchClientSecret fora", fetchClientSecret);


        let clientSecret = fetchClientSecret.clientSecret;

        // const stripePromise = inject("stripe");
        // const stripePromise = new Promise((resolve, reject) => {
        //     const script = document.createElement('script');
        //     script.src = 'https://js.stripe.com/v3/';
        //     script.onload = () => {
        //         resolve(window.Stripe(clientSecret));
        //     };
        //     script.onerror = () => {
        //         reject(new Error('Failed to load Stripe.js'));
        //     };
        //     document.head.appendChild(script);
        // });

        const stripe = await stripePromise;

        console.log('stripePromise', stripePromise);
        console.log("stripe", stripe);
        console.log("stripe.initEmbeddedCheckout", stripe?.initEmbeddedCheckout);

        try{
            if (stripe && stripe.initEmbeddedCheckout) {
                this.checkout = await stripe.initEmbeddedCheckout({
                    clientSecret
                });

                this.$nextTick(() => {
                    console.log("checkout", this.checkout);

                    this.checkout.mount("#checkout");
                });

          // setTimeout(() => {
          //   const iframe = document.querySelector("iframe");
          //   if (iframe) {
          //     console.log('IFRAAAAAAAAAAAAAAAAME', iframe);
          //     console.log('iframe.contentWindow.document.querySelector(".AnimateSinglePresence")', iframe.contentWindow.document.querySelector(".AnimateSinglePresence"));
          //     iframe.contentWindow.document.querySelector(".AnimateSinglePresence").style.display = "none";
          //   }
          // }, 2000); // Espera o carregamento do iframe
            } else {
                console.error("Stripe nÃ£o estÃ¡ inicializado corretamente.");
            }
        }catch(error) {
            console.error("Stripe nÃ£o estÃ¡ inicializado corretamente. Error:", error);
        }
      } catch (err) {
        console.log("Erro ao inicializar o checkout", err);
      }
    }

  }
}
</script>
